// Mock data for Cabinet CAMBC Conseils
import axios from 'axios';
import { API_URL } from '../config/api';

const BACKEND_URL = API_URL;

export const companyInfo = {
  name: "Cabinet CAMBC Conseils",
  address: "46 boulevard Pierre Delbrel, 82200 Moissac",
  phone: "05 82 81 91 20",
  email: "cabinet@cambc-conseils.fr",
  hours: {
    office: "Lundi - Vendredi: 9h00 - 18h00",
    subscription: "Service souscription: 24h/24, 7j/7"
  }
};

export const services = [
  {
    id: 1,
    title: "Assurance Particuliers",
    description: "Protection complète pour vous et votre famille : habitation, auto, santé, prévoyance et bien plus.",
    icon: "Home",
    features: [
      "Assurance habitation",
      "Assurance automobile",
      "Assurance santé",
      "Prévoyance",
      "Assurance prêt bancaire",
      "Bateau / Jet ski",
      "Véhicule collection / Prestige",
      "Dommages ouvrages",
      "Propriétaire non occupant (PNO)"
    ]
  },
  {
    id: 2,
    title: "Assurance Professionnels",
    description: "Solutions adaptées pour protéger votre activité et vos biens professionnels.",
    icon: "Briefcase",
    features: [
      "Responsabilité civile professionnelle",
      "Multirisque professionnelle",
      "Garantie décennale",
      "Flotte automobile",
      "Protection juridique",
      "Assurance prêt bancaire pro",
      "Assurance pro de l'auto",
      "Multirisques bureau",
      "Assurance association",
      "RC réglementée"
    ]
  },
  {
    id: 3,
    title: "Démarches Carte Grise",
    description: "Service complet pour toutes vos démarches d'immatriculation de véhicules.",
    icon: "FileText",
    features: ["Immatriculation neuve", "Changement de propriétaire", "Changement d'adresse", "Duplicata"]
  },
  {
    id: 4,
    title: "Assurance Temporaire 24/7",
    description: "Souscription immédiate à toute heure pour vos besoins d'assurance temporaire.",
    icon: "Clock",
    features: ["Disponible 24h/24", "Souscription en ligne", "Couverture immédiate", "Durée flexible"]
  }
];

export const advantages = [
  {
    id: 1,
    title: "Expertise IARD",
    description: "Spécialistes reconnus en assurance de biens et de responsabilité",
    icon: "Award"
  },
  {
    id: 2,
    title: "Conseil Personnalisé",
    description: "Une écoute attentive pour des solutions sur-mesure",
    icon: "Users"
  },
  {
    id: 3,
    title: "Disponibilité",
    description: "Service de souscription accessible 24h/24 et 7j/7",
    icon: "Clock"
  },
  {
    id: 4,
    title: "Proximité",
    description: "Un cabinet local à votre écoute à Moissac",
    icon: "MapPin"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marie Dupont",
    role: "Particulier",
    content: "Un service exceptionnel et des conseils précieux. Je recommande vivement le Cabinet CAMBC pour leur professionnalisme.",
    rating: 5
  },
  {
    id: 2,
    name: "Jean-Pierre Martin",
    role: "Chef d'entreprise",
    content: "Excellente prise en charge de nos besoins en assurance professionnelle. Une vraie expertise !",
    rating: 5
  },
  {
    id: 3,
    name: "Sophie Bernard",
    role: "Particulier",
    content: "Réactivité et efficacité pour mes démarches de carte grise. Service impeccable !",
    rating: 5
  }
];

// Real API form submission functions
export const submitContactForm = async (formData) => {
  try {
    const response = await axios.post(`${BACKEND_URL}/api/contact`, formData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return { 
      success: true, 
      message: "Votre message a été envoyé avec succès ! Nous vous répondrons dans les plus brefs délais.",
      data: response.data 
    };
  } catch (error) {
    console.error("Error submitting contact form:", error);
    return { 
      success: false, 
      message: "Une erreur est survenue lors de l'envoi. Veuillez réessayer ou nous appeler directement.",
      error: error.message 
    };
  }
};

export const submitQuoteForm = async (formData) => {
  try {
    const response = await axios.post(`${BACKEND_URL}/api/quote`, formData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return { 
      success: true, 
      message: "Votre demande de devis a été envoyée avec succès ! Nous vous contacterons sous 24h.",
      data: response.data 
    };
  } catch (error) {
    console.error("Error submitting quote form:", error);
    return { 
      success: false, 
      message: "Une erreur est survenue lors de l'envoi. Veuillez réessayer ou nous appeler au 05 82 81 91 20.",
      error: error.message 
    };
  }
};

export const submitAppointmentForm = async (formData) => {
  // Note: Appointment form can use the contact endpoint with a specific subject
  try {
    const contactData = {
      ...formData,
      subject: `Demande de rendez-vous - ${formData.subject || 'Non spécifié'}`
    };
    const response = await axios.post(`${BACKEND_URL}/api/contact`, contactData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return { 
      success: true, 
      message: "Votre demande de rendez-vous a été enregistrée avec succès ! Nous vous contacterons pour confirmer.",
      data: response.data 
    };
  } catch (error) {
    console.error("Error submitting appointment form:", error);
    return { 
      success: false, 
      message: "Une erreur est survenue. Veuillez nous appeler directement au 05 82 81 91 20.",
      error: error.message 
    };
  }
};

export const submitTemporaryInsuranceForm = async (formData) => {
  try {
    const response = await axios.post(`${BACKEND_URL}/api/temporary-insurance`, formData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return { 
      success: true, 
      message: "Votre demande d'assurance temporaire a été envoyée avec succès ! Nous vous contactons sous 2 heures.",
      data: response.data 
    };
  } catch (error) {
    console.error("Error submitting temporary insurance form:", error);
    return { 
      success: false, 
      message: "Une erreur est survenue. Veuillez nous appeler au 05 82 81 91 20 (service 24/7).",
      error: error.message 
    };
  }
};
